<import-file [title]="'Import Document'" [isGeneric]="false" [documentType]="documentType.ServicerProfile"
    [attachmentId]="attachmentId" [requiredColumns]="contractRequiredColumns"></import-file>